import React from 'react'

import header from '../../assets/adavita_profile.png';
import profilePicture from '../../assets/adavita_profile_pic.png';

const AdavitaProfilePage = () => {  

    const profileStyle = {
        backgroundColor: '#1F325D',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      };

      const headerStyle = {
        position : 'absolute',
        marginLeft: '100px',
        left: 0,
        top: 0,
        width: '520px', 
        height: 'auto',
      };

      const pictureStyle = {
        position : 'absolute',
        marginLeft: '260px',
        marginTop: '90px',
        left: 0,
        top: 0,
        width: '240px', 
        height: 'auto',
      };

      const squareStyle = {
        position : 'absolute',
        left: 170,
        marginTop: '170px',
        width: '400px',
        height: '120px',
        backgroundColor: 'rgba(31, 50, 93, 0.9)',
        borderRadius: '30px',
      };

        const statusStyle = {
          position : 'absolute',
          left: 725,
          top: '120px',
          width: '600px',
          height: '150px',
          backgroundColor: 'rgba(255, 255, 255, 0)',
          border: '3px solid white', 
          borderRadius: '30px',
        };

        const descriptionStyle = {
            position : 'absolute',
            left: 725,
            top: '360px',
            width: '600px',
            height: '315px',
            backgroundColor: 'rgba(255, 255, 255, 0)',
            border: '3px solid white',
            borderRadius: '30px',
          };
      


    return(
        <div style = {profileStyle}>

            <img src={header} alt="Header Image" style={headerStyle} />

            <img src={profilePicture} alt="Profile Image" style={pictureStyle} />

            <div style={squareStyle}>
            <h1 style = {{marginTop: '30px', fontSize: '50px', marginRight: '65px'}}>@ADAVITA</h1>
            </div>

            <div style={statusStyle}>

                <p style={{
                    fontSize: '25px',
                    lineHeight: '1.5',
                    color: 'white',
                    fontWeight: 'bold',
                    marginLeft: '30px',
                    marginTop: '15px',
                    textAlign: 'left',
                    }}>
                ☆ STATUS
                </p>

                <p style={{
                    fontSize: '18px',
                    lineHeight: '1.5',
                    color: 'white',
                    marginLeft: '30px',
                    marginTop: '-10px',
                    marginRight: '10px',
                    fontFamily: 'Courier',
                    textAlign: 'left',
                    }}>
                    Currently playing League of Legends and learning how to code in React.
                </p>

            </div>

            <div style={descriptionStyle}>

                <p style={{
                    fontSize: '25px',
                    lineHeight: '1.5',
                    color: 'white',
                    fontWeight: 'bold',
                    marginLeft: '30px',
                    marginTop: '15px',
                    textAlign: 'left',
                    }}>
                ☆ DESCRIPTION
                </p>

                <p style={{
                    fontSize: '18px',
                    lineHeight: '1.5',
                    color: 'white',
                    marginLeft: '30px',
                    marginTop: '-10px',
                    marginRight: '30px',
                    fontFamily: 'Courier',
                    textAlign: 'left',
                    }}>
                    Hi there! My name is Adavita Jain and I am a fourth year computer science major and a biology 
                    minor at the University of Buffalo. My favorite thing about my major is how you are able to 
                    take an idea from your imagination and create it into a real product.
                </p>

                <p style={{
                    fontSize: '18px',
                    lineHeight: '1.5',
                    color: 'white',
                    marginLeft: '30px',
                    marginTop: '-10px',
                    marginRight: '30px',
                    fontFamily: 'Courier',
                    textAlign: 'left',
                    }}>
                    Some of my favorite things are: the color purple, the fruit lychee, listening to kpop and cats.
                </p>
                
            </div>

        </div>
    )
}

export default AdavitaProfilePage;